<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListAccount()" isJump />
    <el-button class="m-b-10" type="success" size="mini" @click="itemAdd">新增岗位</el-button>

    <!-- 表格 -->
    <vxe-grid
      size="mini"
      :loading="loading"
      :data="tableDataMain"
      :columns="tableColumn"
      :height="this.$util.getViewHeight() - 36 - 187"
    >
      <!-- slot_header -->
      <!-- 是否启用-表头筛选 -->
      <template #header_is_enabled="{ column }">
        <div class="header-filter-box">
          <div>{{ column.title }}</div>
          <el-select
            v-model="filterData.is_enabled"
            size="mini"
            placeholder="全部"
            clearable
            style="width: 80px"
            @change="searchListData"
          >
            <el-option label="启用" value="true" />
            <el-option label="未启用" value="false" />
          </el-select>
        </div>
      </template>

      <!-- slot_default -->
      <!-- 是否启用-行内开关 -->
      <template #default_is_enabled="{ row }">
        <el-switch
          :active-value="true"
          :inactive-value="false"
          v-model="row.is_enabled"
          @change="itemSwitchEnabled(row, $event)"
        />
      </template>
      <template #default_operate="{ row }">
        <template v-if="row.id !== 1">
          <el-link type="success" @click="itemDetail(row)">权限分配</el-link>
          <el-link type="primary" @click="itemEdit(row)">编辑</el-link>
          <el-link type="danger" @click="itemDelete(row)">删除</el-link>
        </template>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改岗位 -->
    <PopupRole
      v-if="isShowPopupRole"
      :show.sync="isShowPopupRole"
      :data.sync="itemObj"
      @success="getListData"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupRole: () => import('./popup-role')
  },
  data() {
    return {
      loading: true,

      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          field: 'sort_num',
          title: '排序',
          width: 80
        },
        {
          fixed: 'left',
          field: 'name',
          title: '岗位名称'
        },
        { field: 'remark', title: '岗位备注' },
        {
          field: 'is_able_change',
          title: '岗位名字能否编辑',
          titleHelp: {
            message:
              '岗位名字固定不能编辑，用于销售开单等页面下拉筛选！\n(无论是否，权限都可以正常编辑设置)'
          },
          formatter: ({ cellValue }) => {
            if (cellValue == true) {
              return '是'
            } else {
              return '否'
            }
          }
        },
        { field: 'created', width: 180, title: '创建时间' },
        { field: 'user_count', title: '岗位人数', width: 80 },
        {
          fixed: 'right',
          field: 'is_enabled',
          title: '是否启用',
          width: 100,
          slots: {
            header: 'header_is_enabled',
            default: 'default_is_enabled'
          }
        },
        {
          fixed: 'right',
          title: '操作',
          width: 160,
          slots: { default: 'default_operate' }
        }
      ],
      tableDataMain: [],
      pageOptions: {
        ...this.$constant.page
      },
      // 表头筛选条件：is_enabled 为空字符串时表示不过滤
      filterData: {
        is_enabled: ''
      },
      // 默认按排序数值从小到大排序（后端接口默认按 sort_num 升序）
      sortData: {
        sort_num: 'asc'
      },
      isShowPopupRole: false,
      itemDefault: {
        id: '',
        name: '',
        remark: '',
        is_able_change: false,
        sort_num: 0,
        is_enabled: true,
        user_count: 0
      },
      itemObj: {}
    }
  },
  mounted() {
    this.initItemObj()
    this.getListData()
  },
  methods: {
    // 初始化itemObj
    initItemObj() {
      this.itemObj = this.$util.deepCopy(this.itemDefault)
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取数据列表
    getListData() {
      this.loading = true
      // 组装筛选条件，is_enabled 为空时不传，表示不过滤
      let filterData = {}
      if (this.filterData.is_enabled !== '') {
        filterData.is_enabled = this.filterData.is_enabled
      }
      this.$api({
        method: 'post',
        url: '/admin/role/getRoleListPageVue',
        data: {
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          sortData: this.sortData,
          filterData
        }
      })
        .then((res) => {
          this.tableDataMain = res.data.page.list
          this.pageOptions.pageSize = res.data.page.pageSize
          this.pageOptions.total = res.data.page.totalRow
          this.pageOptions.currentPage = res.data.page.pageNumber
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 项-启用/禁用切换：岗位人数大于0时不能取消启用
    itemSwitchEnabled(row, $event) {
      let newValue = $event
      // 岗位人数大于0时不允许取消启用
      if (!newValue && row.user_count > 0) {
        this.$message.warning('岗位人数大于0，不能取消启用')
        row.is_enabled = true
        return
      }
      this.$confirm('确认要改变岗位启用状态 : ' + row.name + '?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let updateData = this.$util.deepCopy(row)
          this.$api({
            method: 'get',
            url: '/admin/role/updateVue',
            params: updateData
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.$message.success('编辑成功')
            }
          })
        })
        .catch(() => {
          row.is_enabled = !newValue
          this.$message.info('已取消操作')
        })
    },
    // 项-新增
    itemAdd() {
      this.isShowPopupRole = true
      this.initItemObj()
    },
    // 项-详情
    itemDetail(row) {
      this.$router.push({ path: '/system/role/detail', query: { id: row.id } })
    },
    // 项-编辑
    itemEdit(row) {
      this.isShowPopupRole = true
      this.itemObj = this.$util.deepCopy(row)
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/role/deleteVue',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
// 是否启用表头筛选样式，与 c-table-header 保持一致
.header-filter-box {
  color: @colorGrayDeep;
  .el-select {
    margin-top: 2px;
    /deep/ .el-input__inner {
      height: 24px;
      line-height: 24px;
      color: @colorGrayDeep;
      width: 100% !important;
      overflow: hidden;
      padding: 0 2px;
      text-align: center;
    }
    // 下拉箭头图标随输入框高度垂直居中
    /deep/ .el-input__icon {
      width: auto;
      line-height: 24px;
    }
    // 箭头区域白底，避免与居中文字重叠时透底
    /deep/ .el-input__suffix-inner {
      background: #fff;
    }
  }
}
</style>
